<template>
  <div :class="listContainerClasses">
    <div v-for="item in items" :key="item.id">
      <NavigationPaneItem
        :id="item.id"
        :label="item.label"
        :href="item.href"
        :expanded="expanded"
        :isSelected="selectedItem === item.id"
        :position="position"
        :disabled="item.disabled"
        :isMobileNav="isMobileNav"
        @click="onSelectItem(item.id)"
      >
        <template v-if="item.icon" #icon>
          <div class="w-6 h-6 flex items-center justify-center">
            <slot :name="`icon-${item.id}`" :item="item">
              <component :is="item.icon" />
            </slot>
          </div>
        </template>
      </NavigationPaneItem>

      <div v-if="item.showDivider" class="my-2 border-t border-white/20 w-full"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { type Position, type NavItem } from '../types/NavigationPane'
import NavigationPaneItem from './NavigationPaneItem.vue'
import { cn } from '../utils/navigationClasses'

export default defineComponent({
  name: 'NavigationPaneList',
  components: {
    NavigationPaneItem
  },
  props: {
    items: {
      type: Array as () => NavItem[],
      required: true
    },
    expanded: {
      type: Boolean,
      default: false
    },
    position: {
      type: String as () => Position,
      default: 'left'
    },
    selectedItem: {
      type: String,
      default: undefined
    },
    isMobileNav: {
      type: Boolean,
      default: false
    }
  },
  emits: ['selectItem'],
  setup(props, { emit }) {
    const onSelectItem = (id: string) => {
      emit('selectItem', id)
    }

    const listContainerClasses = computed(() => {
      const isVertical =
        props.position === 'left' || props.position === 'right' || props.isMobileNav

      return cn('flex gap-2', {
        'flex-col': isVertical,
        'flex-row': !isVertical,
        'items-center justify-center': !isVertical,
        'p-1': true
      })
    })

    return {
      onSelectItem,
      listContainerClasses
    }
  }
})
</script>
